<template>
	<div
		v-on:click="handleClick"
		class="flex justify-center items-center cursor-pointer"
		style="height: 100%"
	>
		{{
			params.data.lowIssues +
			" | " +
			params.data.mediumIssues +
			" | " +
			params.data.highIssues
		}}
	</div>
</template>
  
  <script>
import Vue from "vue";
import SFIssuesDetailsPopUp from "../SFIssuesDetailsPopUp.vue";
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
	components: {
		SFIssuesDetailsPopUp,
	},
	methods: {
		handleClick() {
			this.sfIssuesDetailPopup(this.onePs.id, this.onePs.url);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		sfIssuesDetailPopup(pid, url) {
			let ComponentClass = Vue.extend(SFIssuesDetailsPopUp);
			let technologiesPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prsopect_id: pid,
					prospect_url: url,
				},
			});
			technologiesPopup.$mount();

			this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		},
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>